import { hasRole } from "@/lib/auth";
import { isTransactionMonitoringSurfaceEnabled } from "@/lib/transaction-monitoring-api-base";
import type { RoleId } from "@/types/user-management";
import { useFeatureFlagEnabled } from "posthog-js/react";

const CAN_SEE_COMPLIANCE_SCREEN_FLAG = "can-see-compliance-screen";
const CAN_SEE_TM_BACKED_COMPLIANCE_SCREEN_FLAG =
  "can-see-tm-backed-compliance-screen";
export const COMPLIANCE_REQUIRED_ROLES: RoleId[] = [
  "ACCOUNT_ADMIN",
  "COMPLIANCE",
];

export const hasRolesForCompliance = (authorities: readonly string[]) =>
  COMPLIANCE_REQUIRED_ROLES.some((role) => hasRole(role, authorities));

export const useCanSeeFxBackedComplianceScreen = () => {
  const flagEnabled = useFeatureFlagEnabled(CAN_SEE_COMPLIANCE_SCREEN_FLAG);
  return flagEnabled ?? false;
};

export const useCanSeeTmBackedComplianceScreen = () => {
  const flagEnabled = useFeatureFlagEnabled(
    CAN_SEE_TM_BACKED_COMPLIANCE_SCREEN_FLAG,
  );
  if (
    import.meta.env.VITE_IS_PLAYWRIGHT === "true" ||
    import.meta.env.VITE_TRANSACTION_MONITORING_E2E_BYPASS === "true"
  ) {
    return true;
  }
  if (!isTransactionMonitoringSurfaceEnabled()) {
    return false;
  }
  return flagEnabled ?? false;
};

export const useCanSeeComplianceScreen = () => {
  const tmBacked = useCanSeeTmBackedComplianceScreen();
  const fxBacked = useCanSeeFxBackedComplianceScreen();
  return tmBacked || fxBacked;
};

export const CanSeeComplianceScreen = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const flagEnabled = useCanSeeComplianceScreen();
  return flagEnabled ? children : null;
};
